import { useToastBase } from '@trqk/components';

import { ToastContext } from './ToastContext';

// Extends the base `useToast` from @trqk/components by adding the context for the web app.
// We have to do this on an app-by-app basis because the context is a singleton; otherwise we would
// include this logic within the useToastBase hook.
export const useToast = (): ToastProviderValue => useToastBase(ToastContext);
